export default "__VITE_ASSET__Be7b_2Ox__"